// extracted by mini-css-extract-plugin
module.exports = {"container":"BlogHeader_container__QYzLT","iconAndText":"BlogHeader_iconAndText__95rw7","left":"BlogHeader_left__RJoze"};